<template>
  <div v-if="user">
    <sticky class="page-header sticky-page-header page-header--new" :back-button="true">
      <span slot="left-title">Edition de l'utilisateur <span v-if="user">{{user.first_name}} {{user.last_name}}</span></span>
    </sticky>
    <div class="columns is-gapless is-margin-left-on-btn-actions is-margin-right-on-btn-actions is-padding-top">
      <div class="column is-12 is-9-widescreen is-8-fullhd">
        <div class="has-bg-white is-border">
          <user-form @submit="submit" :source="user" :profiles="profiles"
                   v-if="user && profiles && profiles.length > 0" :loading="loading"></user-form>
        </div>
      </div>
    </div>
  </div>
  <spinner-round :isLoading="loading" v-else></spinner-round>
</template>

<script>
  import UserForm from '@/components/users/UserForm'
  import { mapGetters, mapState } from 'vuex'
  import { Error } from '@/mixins'

  export default {
    name: 'UserEdit',
    data () {
      return {
        user: null,
        loading: true
      }
    },
    components: {
      UserForm
    },
    mixins: [Error],
    computed: {
      ...mapGetters(['currentUserPk']),
      ...mapState(['profilsData']),
      profiles () {
        return this.profilsData
      }
    },
    methods: {
      getUser (id) {
        this.loading = true
        this.$api.userService.getOne(id).then(res => {
          this.loading = false
          this.user = res.data
        }).catch(() => {
          this.loading = false
        })
      },
      submit (user, redirect) {
        this.loading = true
        this.$api.userService.put(user.pk, user).then(res => {
          this.loading = false
          if (this.$route.params.id === this.currentUserPk) {
            this.$store.commit('setCurrentUser', {user: res.data})
            this.$notify({
              type: 'is-success',
              text: 'Votre compte a bien été mis à jour'
            })
            if (redirect) {
              this.$router.push({name: 'UserVue', params: {id: 'me'}})
            }
          } else {
            this.$notify({
              type: 'is-success',
              text: 'L\'utilisateur a bien été mis à jour'
            })
            if (redirect) {
              this.$router.push({name: 'UserVue', params: {id: res.data.pk}})
            }
          }
        }).catch(err => {
          this.loading = false
          this.handleError(err, 'Erreur lors de la mise à jour de l\'utilisateur.')
        })
      }
    },
    created () {
      this.getUser(this.$route.params.id)
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/users/UserEdit.vue